export function Section({ children, className = "", id, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 sm:py-28 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 sm:px-10">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return <p className={`eyebrow ${className}`}>{children}</p>;
}
